import { createClient } from '@supabase/supabase-js'
import fetchRetry from 'fetch-retry'
import { getSupabaseConfig } from '@/lib/config/env'
// import type { Database } from './database.types'

const fetchWithRetry = fetchRetry(fetch, {
  retries: 3,
  retryDelay: (attempt: number) => Math.min(1000 * Math.pow(2, attempt), 10000),
  retryOn: [429, 502, 503, 504],
})

export function createAdminClient() {
  const { url: supabaseUrl, serviceRoleKey } = getSupabaseConfig()

  if (!supabaseUrl || !serviceRoleKey) {
    throw new Error(
      'Supabase admin client cannot be created: URL or service role key is missing. ' +
        'Check your environment configuration.'
    )
  }

  return createClient(supabaseUrl, serviceRoleKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
    global: {
      fetch: fetchWithRetry,
    },
  })
}
